/* Wheels Outlet: exact variant selection and recoverable cart errors. */
(function (window, document) {
  'use strict';
  function byId(variants, id) {
    return variants.filter(function (v) { return String(v.id) === String(id); })[0] || null;
  }
  function initialVariant(variants, id, optionNames, finishOption, finishValue) {
    var explicit = byId(variants, id);
    if (explicit) { return explicit; }
    // A clicked collection finish narrows the default without overriding a specific variant link.
    if (finishOption && finishValue && /(finish|colou?r)/i.test(String(finishOption))) {
      var finishIndex = (optionNames || []).map(function (name) { return String(name).toLowerCase().trim(); })
        .indexOf(String(finishOption).toLowerCase().trim());
      if (finishIndex !== -1) {
        var matching = variants.filter(function (variant) { return variant.options[finishIndex] === finishValue; });
        if (matching.length) { variants = matching; }
      }
    }
    var available = variants.filter(function (variant) { return variant.available; });
    var candidates = available.length ? available : variants;
    var names = optionNames || [];
    var sizes = [], patterns = [];
    names.forEach(function (name, index) {
      if (/\b(?:sizes?|diameter|width)\b/i.test(String(name))) { sizes.push(index); }
      else if (/\b(?:pcd|bolt\s*patterns?)\b/i.test(String(name))) { patterns.push(index); }
    });
    return candidates.map(function (variant, position) { return { variant: variant, position: position }; })
      .sort(function (a, b) {
        for (var i = 0; i < sizes.length; i++) {
          var sizeOrder = compareSizeValues(a.variant.options[sizes[i]], b.variant.options[sizes[i]]);
          if (sizeOrder) { return sizeOrder; }
        }
        for (var p = 0; p < patterns.length; p++) {
          var patternOrder = boltPatternPriority(a.variant.options[patterns[p]]) - boltPatternPriority(b.variant.options[patterns[p]]);
          if (patternOrder) { return patternOrder; }
        }
        return a.position - b.position;
      }).map(function (entry) { return entry.variant; })[0] || null;
  }
  function compareSizeValues(a, b) {
    var left = String(a).match(/\d+(?:\.\d+)?/g) || [];
    var right = String(b).match(/\d+(?:\.\d+)?/g) || [];
    if (!left.length || !right.length) { return left.length ? -1 : (right.length ? 1 : 0); }
    for (var i = 0; i < Math.min(left.length, right.length); i++) {
      var difference = Number(left[i]) - Number(right[i]);
      if (difference) { return difference; }
    }
    return left.length - right.length;
  }
  function boltPatternPriority(value) {
    // Match five-lug patterns exactly, including dual-drilled and PCD/offset labels.
    var pattern = /(?:^|[^\d.])5\s*[x\u00d7]\s*(\d+(?:\.\d+)?)(?![\d.])/gi;
    var rank = 2;
    var match;
    while ((match = pattern.exec(String(value || '')))) {
      var diameter = Number(match[1]);
      if (diameter === 114.3) { return 0; }
      if (diameter === 100) { rank = 1; }
    }
    return rank;
  }
  function optionValues(variants, selected, index, name) {
    var values = [];
    variants.forEach(function (v) {
      for (var i = 0; i < index; i++) { if (v.options[i] !== selected[i]) { return; } }
      if (values.indexOf(v.options[index]) === -1) { values.push(v.options[index]); }
    });
    // Sort sizes numerically by diameter, then width, without changing variant IDs or selection.
    if (/\b(?:sizes?|diameter|width)\b/i.test(String(name || ''))) {
      values = values.map(function (value, position) { return { value: value, position: position }; })
        .sort(function (a, b) { return compareSizeValues(a.value, b.value) || a.position - b.position; })
        .map(function (entry) { return entry.value; });
    } else if (/\b(?:pcd|bolt\s*patterns?)\b/i.test(String(name || ''))) {
      // Values have already been limited to the chosen size and earlier options.
      // Keep all other patterns and offsets in their existing relative order.
      values = values.map(function (value, position) { return { value: value, position: position }; })
        .sort(function (a, b) { return boltPatternPriority(a.value) - boltPatternPriority(b.value) || a.position - b.position; })
        .map(function (entry) { return entry.value; });
    }
    return values;
  }
  function resolveVariant(variants, wanted) {
    var candidates = variants.slice();
    for (var i = 0; candidates.length && i < wanted.length; i++) {
      var matches = candidates.filter(function (v) { return v.options[i] === wanted[i]; });
      if (!matches.length) {
        var fallback = candidates.filter(function (v) { return v.available; })[0] || candidates[0];
        var value = fallback.options[i];
        matches = candidates.filter(function (v) { return v.options[i] === value; });
      }
      candidates = matches;
    }
    return candidates[0] || null;
  }
  function quantity(value) {
    return /^[1-9]\d*$/.test(String(value)) && Number(value) <= 100 ? Number(value) : null;
  }
  function stockState(variant) {
    if (!variant || !variant.available) { return 'out'; }
    return variant.tracked && variant.inventory <= 0 ? 'back' : 'in';
  }
  function responseComplete(body, requested) {
    if (!body || !Array.isArray(body.items)) { return false; }
    var used = [];
    return requested.every(function (wanted) {
      for (var i = 0; i < body.items.length; i++) {
        var item = body.items[i];
        if (used.indexOf(i) !== -1 || String(item.id || item.variant_id) !== String(wanted.id) || !(Number(item.quantity) >= wanted.quantity)) { continue; }
        var propertiesMatch = Object.keys(wanted.properties).every(function (key) {
          return item.properties && String(item.properties[key]) === String(wanted.properties[key]);
        });
        if (propertiesMatch) { used.push(i); return true; }
      }
      return false;
    });
  }
  function messageForError(body, network) {
    if (network) { return 'We could not confirm whether your wheels were added. Review your cart before trying again.'; }
    var message = body && (body.description || body.message);
    return typeof message === 'string' ? message : 'These wheels could not be added. Please check your selection and try again.';
  }
  function cartUrl(root, search) {
    var url = root + 'cart';
    var params = new window.URLSearchParams(search || '');
    var preview = params.get('preview_theme_id');
    return preview && /^\d+$/.test(preview) ? url + '?preview_theme_id=' + encodeURIComponent(preview) : url;
  }
  function variantUrl(href, id) {
    var url = new window.URL(href);
    url.searchParams.set('variant', String(id));
    return url.pathname + url.search + url.hash;
  }
  function init(form) {
    if (form.getAttribute('data-wo-ready') === 'true') { return; }
    var dataNode = form.querySelector('[data-wo-product-json]');
    var data;
    try { data = JSON.parse(dataNode.textContent); } catch (error) { return; }
    var master = form.querySelector('select[name="id"]');
    var qty = form.querySelector('input[name="quantity"]');
    var button = form.querySelector('button[type="submit"]');
    var errorBox = form.querySelector('[data-wo-cart-error]');
    var errorText = form.querySelector('[data-wo-cart-error-text]');
    var reviewLink = form.querySelector('[data-wo-review-cart]');
    if (!master || !qty || !button || !errorBox || !errorText || !reviewLink) { return; }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || data.root || '/';
    var destination = cartUrl(root, window.location.search);
    reviewLink.href = destination;
    var product = document.getElementById('product-' + data.id) || form;
    var landingParams = new window.URLSearchParams(window.location.search || '');
    var requestedVariant = landingParams.get('variant');
    var selected = initialVariant(data.variants, requestedVariant, data.options, landingParams.get('wo_finish_option'), landingParams.get('wo_finish'));
    var controls = [];
    var staggered = null;
    var busy = false;
    var locked = [];

    function text(selector, value) {
      var nodes = product.querySelectorAll(selector);
      for (var i = 0; i < nodes.length; i++) { nodes[i].textContent = value; }
    }
    function money(cents) {
      if (window.Shopify && window.Shopify.formatMoney) {
        return window.Shopify.formatMoney(cents, data.moneyFormat);
      }
      return (cents / 100).toFixed(2) + ' ' + data.currency;
    }
    function clearError() {
      errorBox.hidden = true;
      errorText.textContent = '';
    }
    function showError(message) {
      errorText.textContent = message;
      errorBox.hidden = false;
      errorBox.focus();
    }
    function status() {
      button.disabled = busy || (staggered ? !staggered.ready() : !selected || !selected.available);
      button.textContent = busy ? 'ADDING…' : (staggered ? (staggered.wheelCount() ? 'ADD ' + staggered.wheelCount() + ' WHEELS TO CART' : 'SELECT YOUR WHEELS') : (!selected || !selected.available ? 'OUT OF STOCK' : 'ADD TO CART'));
    }
    function setBusy(value) {
      busy = value;
      form.setAttribute('aria-busy', String(value));
      if (value) {
        locked = Array.prototype.map.call(form.querySelectorAll('select, input, textarea, button'), function (control) {
          var state = { control: control, disabled: control.disabled };
          control.disabled = true;
          return state;
        });
      } else {
        locked.forEach(function (state) { state.control.disabled = state.disabled; });
        locked = [];
      }
      status();
    }
    function notify() {
      master.dispatchEvent(new window.Event('change', { bubbles: true }));
      window.dispatchEvent(new window.CustomEvent('variantChange', { detail: { variant: selected } }));
    }
    function image() {
      if (!selected || !selected.imageId || !window.jQuery) { return; }
      var $cell = window.jQuery('.carousel-cell[data-id="' + selected.imageId + '"]', product);
      var $carousel = $cell.closest('.flickity-enabled');
      if ($cell.length && $carousel.length && typeof $carousel.flickity === 'function') {
        $carousel.flickity('select', $cell.index());
      }
    }
    function sync(updateUrl) {
      master.value = selected ? String(selected.id) : '';
      if (window.WOVehicleCart) window.WOVehicleCart.attach(form);
      var count = quantity(qty.value);
      var total = staggered ? staggered.total() : (selected && count ? selected.price * count : 0);
      text('[data-wo-price-main], .current_price', selected ? selected.money : '');
      var title = product.querySelector('[data-wo-title-base]');
      if (title && selected) {
        var finishIndex = data.options.findIndex(function (name) { return /(finish|colou?r)/i.test(name); });
        var finish = finishIndex >= 0 ? selected.options[finishIndex] : '';
        title.textContent = title.getAttribute('data-wo-title-base') + (finish ? ' ' + finish : '');
      }
      text('.current-sku', selected && selected.sku ? selected.sku : '');
      text('#form_products b.total', money(total));
      var totalElement = form.querySelector('b.total');
      if (totalElement) { totalElement.textContent = money(total); }
      var linePrice = form.querySelector('.first_var');
      if (linePrice) { linePrice.setAttribute('data-price', String(total)); linePrice.textContent = money(total); }
      var stock = stockState(selected);
      var stockText = {
        'in': 'In stock, ships within 1 business day',
        'back': 'Back order: call 213-260-1361 for an ETA before you order',
        'out': 'Out of stock, call 213-260-1361 for an ETA'
      };
      text('[data-wo-stock]', stockText[stock]);
      var badge = product.querySelector('[data-wo-stock]');
      if (badge) { badge.className = 'wo-stock ' + (stock === 'in' ? 'wo-stock--in' : 'wo-stock--out'); }
      var backorder = form.querySelector('.subtotal.withstock p');
      if (backorder) { backorder.style.display = stock === 'back' ? '' : 'none'; }
      var soldOut = form.querySelector('.subtotal.outofstock');
      if (soldOut) { soldOut.style.display = stock === 'out' ? '' : 'none'; }
      var installments = product.querySelector('[data-wo-installments-id]');
      if (installments && selected && installments.value !== String(selected.id)) {
        installments.value = String(selected.id);
        installments.dispatchEvent(new window.Event('change', { bubbles: true }));
      }
      status();
      if (updateUrl && selected && window.history && window.history.replaceState) {
        window.history.replaceState(window.history.state, '', staggered ? staggered.url(window.location.href) : variantUrl(window.location.href, selected.id));
      }
    }
    function renderOptions() {
      controls.forEach(function (control, index) {
        while (control.firstChild) { control.removeChild(control.firstChild); }
        optionValues(data.variants, selected.options, index, data.options[index]).forEach(function (value) {
          var option = document.createElement('option');
          option.value = value;
          option.textContent = value;
          control.appendChild(option);
        });
        control.value = selected.options[index];
      });
    }
    if (window.WOStaggeredPurchase) {
      staggered = window.WOStaggeredPurchase.create({ form: form, data: data, selected: selected, onChange: function (variant) { selected = variant; clearError(); sync(true); notify(); image(); } });
      if (staggered) selected = staggered.selected();
    }
    if (!staggered && selected && !data.hideVariantPicker && !(data.options.length === 1 && data.options[0] === 'Title')) {
      data.options.forEach(function (name, index) {
        var wrapper = document.createElement('div');
        wrapper.className = 'selector-wrapper';
        var label = document.createElement('label');
        var control = document.createElement('select');
        control.id = 'wo-option-' + data.id + '-' + index;
        control.className = 'single-option-selector';
        control.setAttribute('data-wo-option', String(index));
        label.htmlFor = control.id;
        label.textContent = ({ 'pcd': 'Bolt pattern', 'et': 'Offset (mm)', 'offset': 'Offset (mm)', 'pcd et': 'Bolt pattern / offset (mm)' })[String(name).toLowerCase().trim()] || name;
        wrapper.appendChild(label);
        wrapper.appendChild(control);
        master.parentNode.insertBefore(wrapper, master);
        controls.push(control);
        control.addEventListener('change', function () {
          var values = controls.map(function (input) { return input.value; });
          selected = resolveVariant(data.variants, values);
          if (selected) { renderOptions(); }
          clearError();
          sync(true);
          notify();
          image();
        });
      });
      renderOptions();
      master.style.display = 'none';
    } else if (!staggered) {
      master.addEventListener('change', function () {
        selected = byId(data.variants, master.value);
        clearError();
        sync(true);
      });
    }

    function changeQuantity(delta) {
      if (busy) { return; }
      var value = quantity(qty.value) || 1;
      qty.value = String(Math.max(1, Math.min(100, value + delta)));
      clearError();
      sync(false);
    }
    var minus = form.querySelector('.input-number-minus');
    var plus = form.querySelector('.input-number-plus');
    if (minus) { minus.addEventListener('click', function () { changeQuantity(-1); }); }
    if (plus) { plus.addEventListener('click', function () { changeQuantity(1); }); }
    qty.addEventListener('change', function () { clearError(); sync(false); });
    qty.addEventListener('input', function () { clearError(); sync(false); });

    if (window.fetch) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (busy) { return; }
        clearError();
        var variant = byId(data.variants, master.value);
        var count = quantity(qty.value);
        if (!staggered && (!variant || !variant.available)) {
          showError('This wheel option is out of stock. Please choose another option or contact us for an ETA.');
          return;
        }
        if (!staggered && !count) { showError('Please choose a whole-number quantity from 1 to 100.'); return; }
        if (!staggered && variant.tracked && variant.continueSelling === false && variant.inventory < count) {
          showError('There are not enough of this configuration for the selected quantity. Reduce the quantity or choose another option.');
          return;
        }
        var properties = window.WOVehicleCart ? window.WOVehicleCart.properties(form) : {};
        var vehicle = form.querySelector('#make_year_model');
        if (vehicle && vehicle.value.trim()) {
          var manualVehicle = vehicle.value.trim();
          properties['make-year-model'] = manualVehicle;
          if (!properties.Vehicle || (properties.Vehicle.toLowerCase() !== manualVehicle.toLowerCase() && properties.Vehicle.toLowerCase().indexOf(manualVehicle.toLowerCase() + ' · ') !== 0)) {
            properties.Vehicle = manualVehicle;
            delete properties['_Vehicle ID'];
            delete properties.Axle;
          }
        }
        var payload;
        if (staggered) {
          var configuration = staggered.buildItems(properties);
          if (configuration.error) { showError(configuration.error); return; }
          payload = { items: configuration.items };
        } else {
          if (stockState(variant) === 'back' || (variant.tracked && variant.continueSelling && variant.inventory < count)) { properties.order = 'Back order'; }
          payload = { items: [{ id: variant.id, quantity: count, properties: properties }] };
        }
        setBusy(true);
        var abort = window.AbortController ? new window.AbortController() : null;
        var timer = abort ? window.setTimeout(function () { abort.abort(); }, 20000) : null;
        window.fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          signal: abort ? abort.signal : undefined,
          body: JSON.stringify(payload)
        }).then(function (response) {
          return response.json().then(function (body) {
            if (!response.ok || body.status >= 400) {
              var error = new Error(messageForError(body, false) + ' Some items may have been added. Review your cart before trying again.');
              error.cartMessage = true;
              throw error;
            }
            if (!responseComplete(body, payload.items)) {
              throw new Error('Unexpected cart response');
            }
            if (timer) { window.clearTimeout(timer); }
            window.location.assign(destination);
          });
        }).catch(function (error) {
          if (timer) { window.clearTimeout(timer); }
          setBusy(false);
          showError(error.cartMessage ? error.message : messageForError(null, true));
        });
      });
    }
    form.setAttribute('data-wo-ready', 'true');
    sync(false);
    notify();
    image();
    window.addEventListener('load', image, { once: true });
  }
  window.WheelsOutletPurchase = {
    byId: byId, initialVariant: initialVariant, optionValues: optionValues,
    resolveVariant: resolveVariant, quantity: quantity, stockState: stockState,
    messageForError: messageForError, variantUrl: variantUrl, cartUrl: cartUrl, init: init
  };
  function boot() {
    var forms = document.querySelectorAll('form[data-wo-purchase]');
    for (var i = 0; i < forms.length; i++) { init(forms[i]); }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); }
  else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})(window, document);
